import { memo, useMemo } from 'react';

import { localClearingSystemKey, paymentMethodKey } from '../../AddBeneficiaryPopupContent.constants';
import { Fields } from '../Fields/Fields';
import { StepTwoProps } from './StepTwo.types';

export const StepTwo = memo<StepTwoProps>((props) => {
    const { fields = [] } = props;

    const filteredFields = useMemo(() => {
        const paymentMethodFieldData = fields.filter((item) => item.path === paymentMethodKey);
        const localClearingSystemFieldData = fields.filter((item) => item.path === localClearingSystemKey);

        return [...paymentMethodFieldData, ...localClearingSystemFieldData];
    }, [fields]);

    return <Fields fields={filteredFields} />;
});

StepTwo.displayName = 'StepTwo';
